// extracted by mini-css-extract-plugin
export default {"bio":"VX","about":"WX","title":"XX","text":"YX","fun_facts":"ZX","fun":"aY","icon":"bY","bio_header":"cY"};
    if(module.hot) {
      // 1711717534957
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  